import './App.css';
import Navigation from './components/navigation';

function App() {
  return (
    <div className="App">
      
      <Navigation />
    </div>
  );
}

export default App;
